import React, { useRef, useState } from "react";
import { Frown, Loader } from "lucide-react";
import Spacing from "../Spacing";
import { calculateDaysLeft, notify } from "../../helpers";
import { Drawer } from 'vaul';

export default function CancelSubscriptionModal(
  { 
    confirmAction=()=>{}, 
    openModal=false, 
    setOpenModal=()=>{},
    packageInfo={},
    confirmUnsubscribeLoader=false,
    setConfirmUnsubscribeLoader=()=>{},
    previousScrollPosition=0
  }
) {
  const [cancelReason, setCancelReason] = useState("");
  const dropdownRef = useRef(null);

  const handelConfirmUnsubscribe = () => {
    if(cancelReason === "" ) {
      notify("error", "Please provide your cancel reason");
      return;
    }
    confirmAction(cancelReason);
    setConfirmUnsubscribeLoader(true);
  }

  const handleDrawerClose = () => {
    setOpenModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={handleDrawerClose}>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">Delete Record</Drawer.Title>
            <Drawer.Description className="sr-only">Delete a recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="docpro_deleteboxbox">
                  <div className="docpro_iconbox_icon docpro_red_color">
                    <Frown width={85} height={85} />
                  </div>
                  <Spacing lg="20" sm="20" />
                  <div className="docpro_iconbox_right">
                    <h3 className="docpro_fs_20 docpro_mb_0">Are you Sure?</h3>
                    <Spacing lg="10" sm="10" />
                    <p className="docpro_fs_16">
                      You want to <span className="docpro_red_color font-semibold">Cancel</span> this subscription?
                    </p>

                    <div className="docpro_card" style={{ border: '1px solid var(--green)', borderRadius: '8px', padding: '14px 18px' }}>
                      <div className="relative" style={{ textAlign: 'left' }}>
                        <p className="docpro_fs_18 docpro_mb_0">{packageInfo?.title?.replace(/^1 x\s*/, '')}</p>
                        <Spacing lg="10" sm="10" />
                        <p className="docpro_mb_0 docpro_fs_16 docpro_green_color">${packageInfo?.amount} <sup className='docpro_fw_400 docpro_fs_12'>Monthly</sup></p>

                        <div className='absolute bottom-0 right-0'>
                          <span className="docpro_badge docpro_badge_green docpro_fs_12" style={{ fontWeight: 400 }}>{`${calculateDaysLeft(packageInfo?.renew_date)} days left`}</span>
                        </div>
                      </div>
                    </div>
                    <Spacing lg="10" sm="10" />
                    <textarea
                      className="docpro_form_field size_lg"
                      cols="30"
                      rows="3"
                      required
                      placeholder="Write your cancel reason here ..."
                      onChange={(e) => setCancelReason(e.target.value)}
                    ></textarea>

                    <Spacing lg="32" sm="32" />
                    <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                      <button
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDrawerClose();
                        }}
                      >
                        No
                      </button>

                      <button
                        className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_red`}
                        onClick={() => {handelConfirmUnsubscribe()}}
                        disabled={confirmUnsubscribeLoader ? true : false}
                      >
                        Yes, Confirm
                        {confirmUnsubscribeLoader && (
                          <span className="docpro_loading" style={{ backgroundColor: '#cb1d63' }}>
                            <Loader width={20} height={20} />
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
